<template>
    <v-app>
        <v-main class="main">

            <!-- Sidebar -->
            <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
                @update:drawerOpen="drawerOpen = $event" />

            <v-container fluid class="main-content pa-4">

                <!-- Header -->
                <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

                <div class="content">

                    <template v-if="loading">

              <v-col cols="12" v-for="n in 4" :key="n">
                <v-card class="pa-6" rounded="lg">
                  <v-skeleton-loader type="heading" class="mb-4" />
                  <v-skeleton-loader type="text" />
                  <v-skeleton-loader type="text" width="80%" class="mt-2" />
                </v-card>
              </v-col>

            </template>

                    <!-- FULL SCREEN LOADING -->
                     <template v-else>
                    <div v-if="portLoading" class="pa-6">

                        <!-- Title skeleton -->
                        <v-skeleton-loader
                        type="heading"
                        width="300"
                        class="mb-6"
                        />

                        <!-- Grid skeleton -->
                        <v-row>
                        <v-col cols="12" md="12" v-for="n in 6" :key="n">
                            <v-card class="pa-6" rounded="lg">

                            <v-skeleton-loader type="text" width="60%" />
                            <v-skeleton-loader type="text" width="40%" class="mt-2" />

                            <v-divider class="my-4" />

                            <v-skeleton-loader type="text" width="80%" />

                            </v-card>
                        </v-col>
                        </v-row>

                    </div>

                    <!-- ROW -->
                    <v-row class="g-4 mt-4 mb-8" dense>

                        <!-- Transactions -->
                        <v-col cols="12" md="12" class="ps-md-3">
                            <div class="column-title mb-6">
                                <h5 class="m-0 text-left">Portfolio</h5>
                                <hr class="title-separator" />
                            </div>


                            <v-card class="outer-card chart-wrapper" style="border-radius: 8px;" flat>
                                <v-card class="pa-3 inner-transaction-card" flat>
                                    <div class="mb-2">
                                        <h4 class="m-0 text-left">Portfolio Overview</h4>
                                    </div>
                                    <v-card class="outer-card" flat>
                                        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

                                            <!-- FULL WIDTH COLUMN -->
                                            <v-col cols="12">

                                                <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
                                                <v-row dense>

                                                    <!-- LEFT COLUMN -->
                                                    <v-col cols="12" md="12" class="d-flex">



                                                        <v-row class="g-4">
                                                            <v-col cols="12" md="4">
                                                                <v-card class="inner-mini-card flex-grow-1" flat>
                                                                    <div class="pa-3">
                                                                        <div
                                                                            class="text-subtitle-1 font-weight-medium text-grey">
                                                                            Current Value
                                                                        </div>
                                                                        <div class="text-h5 mt-2">{{
                                                                            formatCurrency(totalPortfolioValue) }}</div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>

                                                            <v-col cols="12" md="4">
                                                                <v-card class="inner-mini-card flex-grow-1" flat>
                                                                    <div class="pa-3">
                                                                        <div
                                                                            class="text-subtitle-1 font-weight-medium text-grey">
                                                                            Total Investment
                                                                        </div>
                                                                        <div class="text-h5 mt-2">{{
                                                                            formatCurrency(totalInvested) }}</div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>

                                                            <v-col cols="12" md="4">
                                                                <v-card class="inner-mini-card flex-grow-1" flat>
                                                                    <div class="pa-3">
                                                                        <div
                                                                            class="text-subtitle-1 font-weight-medium text-grey">
                                                                            Total Gain
                                                                        </div>
                                                                        <div class="text-h5 mt-2">{{
                                                                            formatCurrency(totalGain) }}</div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>

                                                </v-row>

                                            </v-col>

                                        </v-row>
                                    </v-card>

                                    <v-row class="g-4 mt-4 mb-8" dense>

                                        <v-col cols="12" sm="12">
                                            <div class="mb-2">
                                                <h4 class="m-0 text-left">Active Investments ({{ activePortfolioCount
                                                    }})</h4>
                                            </div>
                                        </v-col>

                                        <!-- Product Cards -->
                                        <v-col v-for="(portfolios, index) in ActivePortfolios" :key="index" cols="12"
                                            md="4" class="pa-2">
                                            <v-card class="product-card pa-6 h-100" flat>

                                                <!-- TOP: Logo + Name -->
                                                <div class="d-flex align-center gap-2 mb-4">
                                                    <img :src="getImage(portfolios.type_image)"
                                                        @error="handleImageError" class="product-image" />
                                                    <div class="text-left">
                                                        <div class="font-weight-bold text-body-1">
                                                            {{ portfolios.product_type_name }}
                                                        </div>

                                                    </div>
                                                </div>

                                                <!-- INNER CARD -->
                                                <v-card class="inner-mini-card pa-2 mb-3" flat>

                                                    <!--top content-->
                                                    <div class="d-flex justify-space-between">
                                                        <!-- LEFT: Maturity -->
                                                        <div class="text-left">
                                                            <div class="text-caption text-grey">Total Invested</div>
                                                            <div class="font-weight-medium">
                                                                {{ formatCurrency(portfolios.amount_invested) }}
                                                            </div>
                                                        </div>

                                                        <!-- RIGHT: Rate -->
                                                        <div class="text-right">
                                                            <div class="text-caption text-grey">Total Gained</div>
                                                            <div class="font-weight-medium text-green">
                                                                {{ formatCurrency(portfolios.accumulated_yield) }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- DIVIDER -->
                                                    <!-- <v-divider class="my-3" /> -->
                                                    <v-progress-linear
                                                        :model-value="formatNumber(portfolios.percentage_gain)"
                                                        color="green" height="3" rounded class="my-3" />


                                                    <!--bottom content-->
                                                    <div class="d-flex justify-space-between">

                                                        <!-- LEFT -->
                                                        <div class="text-left">
                                                            <div class="text-caption text-grey">Start</div>
                                                            <div class="font-weight-medium">
                                                                {{ formatDate(portfolios.created_at) }}
                                                            </div>
                                                        </div>

                                                        <!-- RIGHT -->
                                                        <div class="text-right">
                                                            <div class="text-caption text-grey">Mature By</div>
                                                            <div class="font-weight-medium text-green">
                                                                {{ formatDate(portfolios.maturity_date) }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </v-card>

                                                <!-- BOTTOM ROW -->
                                                <div class="d-flex mt-auto">
                                                    <div class="ms-auto d-flex align-center gap-2">
                                                        <span
                                                            class="text-caption font-weight-medium text-right clickable-title"
                                                            @click="openInvestment(portfolios)">
                                                            View Portfolio
                                                        </span>
                                                        <v-icon size="16" class="ms-1">mdi-arrow-right-circle</v-icon>
                                                    </div>
                                                </div>

                                            </v-card>
                                        </v-col>

                                    </v-row>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-dialog v-model="investmentDialog" max-width="500">
                        <v-card class="pa-5">

                            <!-- HEADER -->
                            <div class="text-center">
                                <!-- TOP: Logo + Name -->
                                <div class="d-flex align-center gap-2 mb-4">
                                    <img :src="getImage(selectedInvestment.type_image)" @error="handleImageError"
                                        class="product-image" />
                                    <div class="text-left">
                                        <div class="font-weight-bold text-body-1">
                                            Investment Details
                                            <v-icon size="20" color="green">
                                                mdi-chart-line
                                            </v-icon>
                                        </div>
                                        <div class="text-caption text-grey">
                                            {{ selectedInvestment.product_name }}
                                        </div>

                                    </div>
                                </div>




                            </div>

                            <!-- DETAILS CARD -->
                            <v-card class="mt-5 pa-4 inner-card-receipt" variant="">

                                <div v-for="(item, index) in investmentItems" :key="index">

                                    <v-row class="pa-5 align-center">

                                        <!-- LABEL -->
                                        <v-col cols="5" class="text-caption text-grey">
                                            {{ item.label }}
                                        </v-col>

                                        <!-- VALUE -->
                                        <v-col cols="7" class="text-body-2 font-weight-medium text-right">
                                            {{ item.value }}
                                        </v-col>

                                    </v-row>

                                    <v-divider v-if="index !== investmentItems.length - 1" />

                                </div>

                            </v-card>

                            <!-- DOWNLOAD BUTTON -->
                            <v-btn class="mt-5 theme-button" block @click="downloadPDF(selectedInvestment)">
                                
                                <span v-if="!downloading">Download PDF <v-icon end>mdi-cloud-download-outline</v-icon></span>
                                <span v-else>Downloading <v-icon start class="spin">mdi-loading</v-icon></span>
                            </v-btn>

                        </v-card>
                    </v-dialog>

                    <!-- PDF Template -->
                    <div ref="pdfRef" class="pdf-receipt">

                        <div class="pdf-header">
                            <img :src="logo" class="pdf-logo" />
                            <h3>{{ selectedInvestment?.product_name }} Investment summary</h3>
                        </div>

                        <!-- <div class="pdf-amount text-center">

                            <img :src="getImage(selectedInvestment?.type_image)" class="pdf-logo" />

                            <h3 class="mt-2">
                                {{ selectedInvestment?.product_type_name }}
                            </h3>

                        </div> -->

                        <div class="pdf-body">
                            <div class="pdf-row" v-for="(item, i) in investmentItems" :key="i">
                                <span>{{ item.label }}</span>
                                <span>{{ item.value }}</span>
                            </div>
                        </div>

                        <div class="pdf-footer">
                            <p>Powered by {{ company }}</p>
                            <p class="text-green">{{ web }}</p>
                            <p>{{ formatDate(new Date()) }}</p>
                        </div>
                    </div>
                    </template>
                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useRoute } from "vue-router"
import { useTransactStore } from "@/store/transaction"
import { useInvStore } from "@/store/investment"
import { STORAGE_URL } from "@/api/env"
import avatarImage from '@/assets/crowdital-icon.png'
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import logo from '@/assets/crowdital-icon.png'

// ChartJS.register(ArcElement, Tooltip, Legend)
import { formatCurrency, formatDate, formatNumber } from "@/util"

//piniastore
const trn = useTransactStore()
const port = useInvStore()
const route = useRoute()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const investmentDialog = ref(false)
const selectedInvestment = ref(null)
const pdfRef = ref(null)
const downloading = ref(false)
const loading = ref(true)
const portLoading = ref(true)

//Product type image
const defaultImage = avatarImage

const getImage = (image) => {
    return image ? `${STORAGE_URL}/${image}` : defaultImage
}

const handleImageError = (event) => {
    event.target.src = defaultImage
}

/* Mobile */
const toggleSidebar = () => {
    if (isMobile.value) drawerOpen.value = !drawerOpen.value
    else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
    drawerOpen.value = !isMobile.value
}

const portfolioItem = computed(() => port.portfolioItem || [])
const totalInvested = computed(() => portfolioItem.value.total_invested) || 0
const totalGain = computed(() => portfolioItem.value.total_accumulated_yield) || 0
const totalPortfolioValue = computed(() => totalInvested.value + totalGain.value)
const activePortfolioCount = computed(() => portfolioItem.value.status_breakdown?.active || 0)
const ActivePortfolios = computed(() => portfolioItem.value.investments || [])

/* Lifecycle */
const productId = route.params.id
onMounted(async () => {
    checkMobile()
    window.addEventListener("resize", checkMobile)
    loading.value = true
    await trn.loadTransaction()
    await port.showPortfolioItem(productId)
    loading.value = false
    portLoading.value = false
})

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile)
})



const openInvestment = (portfolio) => {
    selectedInvestment.value = portfolio || null
    investmentDialog.value = true
}

const investmentItems = computed(() => {
    const p = selectedInvestment.value || {}

    return [
        { label: "Total Invested", value: formatCurrency(p.amount_invested) },
        { label: "Interest Rate", value: formatCurrency(p.interest_rate) },
        { label: "Tenure", value: p.minimum_tenure ? `${p.minimum_tenure} Days` : 'N/A' },
        { label: "Total Gains", value: formatCurrency(p.accumulated_yield) },

        {
            label: "Current Value",
            value: formatCurrency(
                Number(p.amount_invested || 0) + Number(p.accumulated_yield || 0)
            )
        },

        { label: "Estimated Final Payout", value: formatCurrency(p.expected_payout) },

        {
            label: "Growth",
            value: p.percentage_gain
                ? `${(p.percentage_gain).toFixed(2)} %`
                : "0%"
        },

        { label: "Start Date", value: formatDate(p.created_at) },
        { label: "Maturity Date", value: formatDate(p.maturity_date) }
    ]
})

//Download PDF
const downloadPDF = async (inv) => {
    downloading.value = true
    //console.log('Downloading PDF for transaction:', inv) // Debug log
    if (!inv) return

    await document.fonts.ready

    const element = pdfRef.value

    const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: false
    })

    const imgData = canvas.toDataURL("image/png")

    const pdf = new jsPDF("p", "mm", "a4")

    const pageWidth = 210
    const pageHeight = 297

    const imgHeight = (canvas.height * pageWidth) / canvas.width

    let heightLeft = imgHeight
    let position = 0

    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight)

    heightLeft -= pageHeight

    while (heightLeft > 0) {
        position -= pageHeight
        pdf.addPage()
        pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight)
        heightLeft -= pageHeight
    }

    pdf.save(`Investment-${inv.productId || "receipt"}.pdf`)
    downloading.value = false
}

</script>

<style scoped>
.main {
    display: flex;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    background: #f8fafc;
}

.content {
    padding-left: 10%;
    padding-right: 10%;
}

/* Card */
.table-card {
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

/* Table */
.modern-table {
    border: none;
}

/* Product */
.product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 2%;
}

.product-name {
    font-weight: 700;
}

.product-desc {
    font-size: 16px;
    color: #64748b;
}

.clickable-title {
    cursor: pointer;
    transition: 0.2s ease;
}

.clickable-title:hover {
    opacity: 0.7;
}

/* Status */
.status-pill {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
}

.status-active {
    background: #ecfdf5;
    color: #16a34a;
}

.status-inactive {
    background: #fef2f2;
    color: #dc2626;
}

/* Search input */
.search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 8px;
    color: #64748b;
}

.search-wrapper input {
    padding-left: 28px;
}

/* Button */
.theme-button {
    height: 46px;
    background: #0f2638;
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.25s ease;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
    background: #eef7f0;
    color: #065f46;
    font-weight: 600;
    border-bottom: 2px solid #c1edc3;
}

/* Column title */
.column-title h5 {
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
    border: none;
    height: 1px;
    background-color: #eae5e5;
    margin: 0;
    margin-bottom: 8px;
}

.product-card {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

/* Outer card wrapping the 4 inner cards */
.outer-card {
    border: 1px solid #e4dede;
    border-radius: 8px;
    background: #fff;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
}

/* Inner cards */
.inner-card {
    border: 1px solid #eae5e5;
    border-radius: 6px;
    padding: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.inner-mini-card {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #ffffff;
}

.fill-height {
    height: 100%;
}

.inner-card-receipt {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fafafa;
}

/*PDF Download */
.pdf-receipt {
    width: 600px;
    padding: 24px;
    background: #fff;
    font-family: Arial, sans-serif;
    position: absolute;
    left: -9999px;
    top: 0;
}

.pdf-header {
    text-align: center;
    margin-bottom: 20px;
}

.pdf-header h3 {
    color: #0f2638;
}

.pdf-logo {
    width: 120px;
    margin-bottom: 10px;
}

.pdf-amount {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0;
}

.pdf-body {
    border-top: 1px solid #eee;
    margin-top: 10px;
}

.pdf-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
}

.pdf-footer {
    text-align: center;
    margin-top: 20px;
    font-size: 12px;
    color: #888;
}

.pdf-receipt {
    max-width: 100%;
}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


/* Mobile */
@media (max-width: 600px) {
    .content {
        padding: 0;
    }

    .avatar-mobile {
        width: 32px;
        height: 32px;
    }

    .title-mobile {
        font-size: 0.9rem;
    }

    .icon-mobile {
        font-size: 16px;
    }
}
</style>
